<div class="chart-section-wrapper">
	<asset-chart-with-settings
		[assetPk]="assetPk()"
		[series]="seriesSections()"
		[showNewGraphSettingsComponent]="showNewGraphSettingsComponent()"
		(hideNewGraphSettings)="closeNewGraphComponent()"
		[title]="'measurements' | translate"
	/>
	<button
		(click)="$event.stopPropagation()"
		[matMenuTriggerFor]="entityMenu"
		class="au-add-fab-button add-graph-button"
	>
		<mat-icon class="accent-icon" svgIcon="add">add</mat-icon>
	</button>
</div>

<mat-menu
	#entityMenu="matMenu"
	[xPosition]="'after'"
	[yPosition]="'below'"
	class="au-select-actions"
>
	<button (click)="addElementToGraphList()" class="accent-button" mat-menu-item>
		<mat-icon class="secondary-text-icon">insert_chart_outlined</mat-icon>
		<span>{{ 'add_component' | translate }}</span>
	</button>
</mat-menu>
